import { parseApiDate } from "./dates";

/**
 * When a trial ends, in words, counted in calendar days on the viewer's clock.
 *
 * The API's trialDaysRemaining is whole 24-hour periods rounded down, so it
 * reads 0 for the entire last day and produced "ends in 0 days".
 */
export function trialEndsLabel(trialEndsAt: string, now: Date = new Date()): string {
  const end = parseApiDate(trialEndsAt);
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.max(0, Math.round((startOfDay(end) - startOfDay(now)) / 86_400_000));

  if (days === 0) return "today";
  if (days === 1) return "tomorrow";
  return `in ${days} days`;
}
